import { useSyncExternalStore } from "react";

const STORAGE_KEY = "assetLocalization.sectionExpanded";
const listeners = new Set<() => void>();

const load = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

let expanded = load();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setLocalizationSectionExpanded = (value: boolean) => {
  expanded = value;
  try {
    localStorage.setItem(STORAGE_KEY, String(value));
  } catch {
    // Storage unavailable (private mode): the choice still holds until the next reload.
  }
  listeners.forEach((listener) => listener());
};

/**
 * Whether the image-localization section is open — one choice for every bubble and interaction.
 * Folded by default: most people never localize an image. Opened once, it stays open while selecting
 * other elements and across reloads.
 */
export const useLocalizationSectionExpanded = () => {
  const value = useSyncExternalStore(subscribe, () => expanded);
  return [value, setLocalizationSectionExpanded] as const;
};
